/**
 * @generated SignedSource<<84cf195628bf3675cc7e73399f91c9fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetVideoTitleVideo$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetVideoTitleVideo";
};
export type helpersGetVideoTitleVideo$key = {
  readonly " $data"?: helpersGetVideoTitleVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetVideoTitleVideo">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetVideoTitleVideo"
};

(node as any).hash = "79e64aab2933a0c8f09429a0e47f5517";

export default node;
